<template>
  <div v-if="DEPLOY_MODE!='production'">

    <v-container text-xs-center>

      <v-layout justify-start wrap>

        <!-- 各種設定 -->
        <v-flex xs12 lg3 class="expand-apriltag-form pr-4">

          <v-layout justify-center>
            <h2>拡張AprilTag デモ</h2>
          </v-layout>

          <v-layout justify-center class="ma-3">
            <span class="caption grey--text text--darken-1">
              テストサイトなのでまだID指定や大きさ指定ができません。<br>
              Tag36h10を使用していて、IDはランダムに表示されます。
            </span>
          </v-layout>

          <!-- #### 表示形式フォーム　マーカー形状設定部分 ### -->
          <v-layout row wrap justify-center align-center>

            <v-flex>
              <v-radio-group v-model="rowInGroup" row hide-details>
                行：
                <v-radio label="1" value="1"></v-radio>
                <v-radio label="2" value="2"></v-radio>
                <v-radio label="3" value="3"></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex>
              <v-radio-group v-model="colInGroup" row hide-details>
                列：
                <v-radio label="1" value="1"></v-radio>
                <v-radio label="2" value="2"></v-radio>
                <v-radio label="3" value="3"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex class="pa-2">
              <div class="">
                <v-switch label="ID表示" v-model="showId" hide-details></v-switch>
              </div>
            </v-flex>

            <!-- 幅スライダー -->
            <v-flex class="pa-2">

              <v-layout>
                <v-flex>
                  <v-slider label="サイズ" v-model="width" :max="20" :min="1" :step="0.5"></v-slider>
                </v-flex>

                <v-flex style="width:100px">
                  <v-text-field v-model="width" class="ml-2" hide-details single-line type="number" suffix="mm">
                  </v-text-field>
                </v-flex>
              </v-layout>

            </v-flex>

            <v-flex style="width:100px" class="pa-2">
              <v-text-field v-model="row" label="縦" class="" hide-details type="number"></v-text-field>
            </v-flex>
            <v-flex style="width:100px" class="pa-2">
              <v-text-field v-model="col" label="横" class="" hide-details type="number"></v-text-field>
            </v-flex>
          </v-layout>


        </v-flex>
        <v-flex xs12 lg9>

          <!-- 下部のタグリスト -->
          <v-layout align-center justify-center>
            <article>
              <section v-for="page in pages" class="print_pages mb-5" :key="page">
                <div>
                  <show-group :row="Number(row)" :col="Number(col)" :rowInGroup="Number(rowInGroup)" :colInGroup="Number(colInGroup)"
                    :showId="showId" :width="Number(width)" />
                </div>
              </section>
            </article>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
let MAXID_36h11 = 586;
let MAXID_36h10 = 2319;
let A4PAGE_WIDTH = 190;  //210mm
let A4PAGE_HEIGHT = 267; //297mm

import ExpandHelper from '@/components/AprilTag/AprilTagExpandHelper'

export default {
  name: 'AprilTagList',
  metaInfo: {
    title:'groma | Expand Tag download'
  },
  components: {
    showGroup: ExpandHelper
  },
  data() {
    return {
      DEPLOY_MODE : process.env.DEPLOY_MODE,
      rowInGroup:"3",
      colInGroup:"3",
      id:{
        from:0,
        to:9
      },
      tagFamily:'Tag36h10',
      width:18,
      row:4,
      col:4,
      showId:true,
      maxId: MAXID_36h11,
      A4PAGE:{
        width:200, //210mm
        height:267, //297mm
      },
      a4AutoFit:true,
      form:{
        width:18,
        from:0,
        to:99
      },
      pages:1
    }
  },
  computed: {
  },
  watch: {
    showNum(){
      this.imgReload();
    },
  },
  methods: {

    count(page,i,j) {
      return this.id.from + (this.col * this.row * (page-1) + this.col * (i-1) + (j-1));
    },

    filename(k,l) {

      let min = 0;
      let max = 999
      let count = Math.floor( Math.random() * (max + 1 - min) ) + min ;

      // k行l列のタグのIDをランダムで決める
      if(k!=1||l!=1){
        // スタートタグじゃないとき
        count += 1000;
      }
      
      let formatNum = ( '00000' + count ).slice( -5 );              
      if(this.tagFamily == 'Tag36h11') {
        return require('@/tag/36h11/tag36_11_' + formatNum + '_100x100.png')
      } else {
        return require('@/tag/36h10/tag36_10_' + formatNum + '_100x100.png')
      }
    },


    idRangeOnPage(page){

      var fromIdOnPage = this.id.from + (page - 1) * this.col * this.row;
      var toIdOnPage = this.id.from + page * this.col * this.row - 1 ;
      if (toIdOnPage > this.id.to) toIdOnPage = this.id.to;
      
      return  fromIdOnPage + " ~ " + toIdOnPage;
    }
  },

  created() {

    this.form.width = this.width;
    this.form.from = this.id.from;
    this.form.to = this.id.to;
    
  },
  mounted(){
    // this.imgReload();
  }
}
</script>

<style scoped>
@media print {
  .expand-apriltag-form {
    display: none;
  }
  .links {
    display: none !important;
  }
  #wovn-translate-widget {
    display: none !important;
  }
  .wovn-lang-selector {
    display: none !important;
  }
  .container {
    margin: 0 !important;
  }

  a[href]:after {
    content: "" !important;
  }
  abbr[title]:after {
    content: "" !important;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/AprilTag/AprilTagExpandDownload.vue